import { Injectable } from '@angular/core';
import { v4 as uuid} from 'uuid'
import { LocalDataStorageService } from './local-data-storage.service';
@Injectable({
  providedIn: 'root',
})
export class UniqueGuidService {

  constructor(
    private storage: LocalDataStorageService
  ) {}

  private generateUniqueGuid(): string {

    const uniqueGuid = this.createUniqueGuid();

    this.storage.storeAnonymousGuid(uniqueGuid); 

    return uniqueGuid;
  }

  public createUniqueGuid(): string {
    const uniqueGuid = uuid();
    return uniqueGuid;
  }

  getUniqueGuid(): string {
    return this.storage.getAnonymousGuid();
  }

  getOrCreateUniqueGuid(): string {
    let result = this.getUniqueGuid();

    if (!result) {
      result = this.generateUniqueGuid();
    }

    return result;
  }
}
